<template>
    <div>
        <div class="bigDiv">
            <div class="h-piece">
                <div>
                    <div class="pieceCon n-bu">
                        <div class="h-pieceCon2">
                            <el-form :model="add" label-position="right" ref="f" :inline="true" :rules="rules"
                                     class="demo-ruleForm h-formbLine h-formbLine1">
                                <div class="h-rowCon1 Bianji">
                                    <el-form-item label="区域" prop="areaCode" class="h-elformWrap-2">
                                        <brselect category="show_area" v-model="add.areaCode" :v="add.areaCode" :clearable="true"
                                                  :disabled="this.disabled" @change="matchsalesman($event)"></brselect>
                                    </el-form-item>
                                    <el-form-item label="省" prop="province" class="h-elformWrap-2">
                                        <el-select v-model="add.province" filterable clearable @change="handleItemChange1($event)" placeholder="省" style="width: 80%;">
                                            <el-option
                                                    v-for="item in shenglist"
                                                    :key="item.value"
                                                    :label="item.name"
                                                    :value="item.code">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="市" prop="city" class="h-elformWrap-2">
                                        <el-select v-model="add.city" filterable clearable @change="handleItemChange2($event)"
                                                   placeholder="市" style="width: 100%;">
                                            <el-option
                                                    v-for="item in cityList"
                                                    :key="item.name"
                                                    :label="item.name"
                                                    :value="item.name">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="渠道" prop="channelCode" class="h-elformWrap-2">
                                        <brselect category="clue_channel" v-model="add.channelCode" :v="add.channelCode" :clearable="true"
                                                  :disabled="this.disabled"></brselect>
                                    </el-form-item>

                                    <el-form-item label="销售人员" prop="salesManName" class="h-elformWrap-2">
                                        <el-select v-model="add.salesManName" @change="salesmanChange($event)"
                                                   placeholder="销售人员" style="width: 100%;" :clearable="true" >
                                            <el-option
                                                    v-for="item in salesmanList"
                                                    :key="item.id"
                                                    :label="item.userName"
                                                    :value="item.userName">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="线索来源" prop="clueFrom" class="h-elformWrap-2">
                                        <el-select v-model="add.clueFrom" filterable class="h-tableInput">
                                            <el-option v-for="(item,index) in resourceList" :key="index" :label="item.clueResourceName" :value="item.clueResourceType" >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item  label="用户单位" prop='userUnitName' class="h-elformWrap-2">
                                        <el-input v-model="add.userUnitName" :disabled="this.disabled"  placeholder="请输入">
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item  label="负责人" prop='leader' class="h-elformWrap-2">
                                        <el-input v-model="add.leader" :disabled="this.disabled"  placeholder="请输入">
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item  label="来电电话" prop='incomingCall' class="h-elformWrap-2">
                                        <el-input v-model="add.incomingCall" :disabled="this.disabled" placeholder="请输入">
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item  label="联系方式" prop='telephone' class="h-elformWrap-2">
                                        <el-input v-model="add.telephone" :disabled="this.disabled" placeholder="请输入">
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item  label="用户需求" prop='userRequire' class="h-elformWrap-2">
                                        <el-input v-model="add.userRequire" :disabled="this.disabled"  placeholder="请输入">
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item  label="备注" prop='memo' class="h-elformWrap-2">
                                        <el-input v-model="add.memo" :disabled="this.disabled"  placeholder="请输入">
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-row style="display: flex;justify-content: center;margin: 30px 0;">
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="save()">确认提交</el-button>
        </el-row>
    </div>
</template>
<script>
    import ss from "../../../api/SystemService";
    import Treeselect from '@riophae/vue-treeselect'
    export default {
        comments: {Treeselect},
        data() {
            return {
                add:{
                    id:'',
                    areaCode:'',
                    province:'',
                    city:'',
                    salesManName:'',
                    salesManCode:'',
                    channelCode:'',
                    clueFrom:'',
                    userUnitName:'',
                    dept:'',
                    leader:'',
                    incomingCall:'',
                    telephone:'',
                    proCategory:'',
                    funnelCode:'',
                    userRequire:'',
                    memo:'',
                    chainGroup:'',
                    chainCode:'',
                    ids: [],  //checkbook 的 id
                    trackStatus:'',
                },
                salesmanList:[],
                cityList:[],
                shenglist:[],
                resourceList:[],
                disabled:false,
                rules: {
                    city: [{required: true, message: '请选择城市', trigger: 'change'}],
                    channelCode: [{required: true, message: '请选择渠道', trigger: 'change'}],
                    areaCode: [{required: true, message: '请选择渠道', trigger: 'change'}],
                    salesManName: [{required: true, message: '请选择销售人员', trigger: 'change'}],
                    telephone: [{required: true, message: '请填写电话', trigger: 'blur'}],
                    userRequire: [{required: true, message: '请填写用户需求', trigger: 'blur'}],
                },
            }
        },
        methods:{
//选中 区域带出销售人员
            matchsalesman(province){

                //选中区域 默认是 显示 直辖市的（市辖区）省
                var areaitem = province.des;
                if (areaitem == '北京' || areaitem == '天津'|| areaitem =='上海' || areaitem == '重庆'){
                    areaitem = areaitem + '市';
                    this.add.province = areaitem;
                    this.add.city = '市辖区'
                }else if (areaitem != '苏州' && areaitem != '深圳'){
                    if (areaitem == '广西'){
                        areaitem = areaitem + '壮族自治区';
                        this.add.province = areaitem;
                        this.add.city = '';
                    }else if (areaitem == '宁夏'){
                        areaitem = areaitem + '回族自治区';
                        this.add.province = areaitem;
                        this.add.city = '';
                    }else if (areaitem == '内蒙古'){
                        areaitem = areaitem + '自治区';
                        this.add.province = areaitem;
                        this.add.city = '';
                    }else if (areaitem == '新疆'){
                        areaitem = areaitem + '维吾尔自治区';
                        this.add.province = areaitem;
                        this.add.city = '';
                    }else if  (areaitem == '西藏'){
                        areaitem = areaitem + '自治区';
                        this.add.province = areaitem;
                        this.add.city = '';
                    }else {
                        areaitem = areaitem + '省';
                        this.add.province = areaitem;
                        this.add.city = '';
                    }
                }else {
                    this.add.province = '';
                    this.add.city = '';
                    this.cityList = null;
                }
                //差该区域下的销售人员
                ss.UserService.selectUserNamesBydaquAndarea(province.des).then(names => {
                    this.salesmanList = names.obj;
                })
                //查询 城市列表'
                var product = _.find(this.shenglist, {name: areaitem});
                if (product != null){
                    ss.Dictservice.getCity({code: product.code}).then(rd => {
                        this.cityList = rd.zlist;
                    })
                }
            },
            // 省份选择器
            handleItemChange1(o, salesman, city) {
                console.log(salesman);
                this.city = city;
                if (city == null) {
                    this.city = null;
                }
                if (salesman == null) {
                    this.salesman = null;
                }
                this.add.provinceList = _.find(this.shenglist, {code: o});
                this.add.province = this.add.provinceList.name;
                this.loudmain.province = this.add.provinceList.name;
                ss.Dictservice.getCity({code: o}).then(rd => {
                    this.cityList = rd.zlist;
                })
            },
            handleItemChange2(o) {
                this.add.city = o;
            },
            salesmanChange(o) {
                this.add.salesManName = o;
            },
            loadArea(i) {
                let proSelect = {
                    pcode: 0,
                    level: 1,
                }
                console.log(proSelect)
                ss.Dictservice.arealist(proSelect).then(rd => {
                    this.shenglist = rd;
                })
            },
            loadClueResource(){
                ss.BscClueManage.getClueResource().then(rd =>{
                    if(rd.f){
                        this.resourceList = rd.msg;
                        this.add.clueFrom = '018';
                    }
                })
            },
            save(){

                var subflag = false;

                this.$refs['f'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });

                if(subflag){

                    //处理 a 标签 出来问题
                    var length = this.add.userRequire.length;
                    if (length > 48){
                        this.$message({
                            type: "error",
                            message: '用户需求不能超过50字！'
                        });
                        return false;
                    }

                    ss.BscClueManage.insertbcp(this.add).then(res => {
                        if(res.f == true ){
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                }

            },
            changeClueFrom(o){
                alert(1)
                var obj = _.filter(this.resourceList,(o)=>{
                    return _.includes(v,o.code)
                })
                alert(obj)
                this.$emit('change',obj)
            },
        },
        created() {
            // this.add.clueFrom = this.$route.query.clueResourceType;

            this.loadArea();
            this.loadClueResource();
        },
    }
</script>
<style>
    .Bianji .h-elformWrap-2 .el-form-item__label {
        width: 26%;
        text-align: right;
    }
    .Bianji .h-elformWrap-2 .el-form-item__content {
        width: 74%;
    }
    .Bianji .h-elformWrap-1 .el-form-item__label {
        width: 8%;
        text-align: right;
    }
    .Bianji .h-elformWrap-1 .el-form-item__content {
        width: 92%;
    }
    .Bianji .h-elformWrap-2 {
        width: 33.333% !important;
        padding-right: 0.5rem
    }
    .Bianji .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }
    .w-elformWrap .el-form-item__label {
        width: 10% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 90% !important;
    }
    .ljjtablepaddings9 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings9 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .bigDiv {
        margin: 20px;
    }
    .bigDiv .h-piece .top .ccc {
        margin-top: -13px;
    }

    .h-rowCon1 {
        padding-top: 0.22rem;
        padding-bottom: 0rem;
        font-size: 16px;
        position: relative;
    }
</style>
